import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { useAppDispatch } from "../../../App/hooks";
import { Additional } from "./Additional";
import {
  IDeltaHedgeOrderFormValues,
  IDeltaHedgeOrderTableReport,
  IDeltaHedgeOrderTablesSearchParam,
} from "../../../Interfaces/deltaHedgeOrder";
import { setDeltaHedgeOrderFormValues } from "../../../Features/DeltaHedgeOrder/deltaHedgeOrderSlice";
import { store } from "../../../App/store";
import { getDeltaHedgeOrderTradeTable } from "../../../Requests/deltaHedgeOrder";
import { StepOrderSide } from "../../../Interfaces/stepInterfaces";

interface IProps {
  searchParam: IDeltaHedgeOrderTablesSearchParam;
}

const DeltaHedgeOrderTradeTable = ({ searchParam }: IProps) => {
  const dispatch = useAppDispatch();

  const tableRowClickHandler = (row: IDeltaHedgeOrderTableReport) => {
    dispatch(
      setDeltaHedgeOrderFormValues({
        ...(store.getState().deltaHedgeOrder?.addOrderFormValues ||
          ({} as IDeltaHedgeOrderFormValues)),
        instrumentId1: row.instrumentIds[0],
        optionOrderType1: row.optionOrderType1,
        orderSide1:
          row.orderSideStr?.split("_")[0]?.trim() === "خرید"
            ? StepOrderSide.Buy
            : StepOrderSide.Sell,
        instrumentId2: row.instrumentIds[1],
        optionOrderType2: row.optionOrderType2,
        orderSide2:
          row.orderSideStr?.split("_")[1]?.trim() === "خرید"
            ? StepOrderSide.Buy
            : StepOrderSide.Sell,
      })
    );
  };

  return (
    <div className="flex flex-col gap-3 justify-start items-end w-full trade-table relative">
      {/* <div className="w-8 cursor-pointer absolute top-0 -left-10">
        <FileDownloader getFile={() => getNLegTradeExcel(searchParam)} />
      </div> */}
      <TableTemplate<
        IDeltaHedgeOrderTablesSearchParam,
        IDeltaHedgeOrderTableReport
      >
        refreshTableTime={5000}
        withSort
        getDataTable={getDeltaHedgeOrderTradeTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            onTableRowClick={tableRowClickHandler}
            sortingType={sortingType}
            setSortingType={setSortingType}
            AdditionalBody={Additional}
            tableBoxClassName="max-h-[500px] overflow-auto"
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default DeltaHedgeOrderTradeTable;
